import { render, staticRenderFns } from "./BaseDivisionSelector.vue?vue&type=template&id=398ed08c"
import script from "./BaseDivisionSelector.vue?vue&type=script&lang=js"
export * from "./BaseDivisionSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseDivisionSelector.vue?vue&type=style&index=0&id=398ed08c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports